import React from "react";
import { useTranslation } from "react-i18next";
import { MemberManagement } from "../features/members/Main";
import { withRestaurantId } from "../shared/components/layout";

const MemberManagementWithId = withRestaurantId(MemberManagement);

const MemberManagementPage: React.FC = () => {
  const { t } = useTranslation();

  return <MemberManagementWithId />;
};

export default MemberManagementPage;
